<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :class="'abow_dialog'"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              睿终端拜访报告信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="走访日期"
                  >
                    <el-input
                      v-model="storeReportForm.visitDateStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="走访人">
                    <el-input
                      v-model="storeReportForm.visitUserName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="签到时间">
                    <el-input
                      v-model="storeReportForm.dingCheckDateStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="签到地址">
                    <el-input
                      v-model="storeReportForm.dingAddress"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="所在省区">
                    <el-input
                      v-model="storeForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="所在城市">
                    <el-input
                      v-model="storeForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="零售户类型">
                    <el-input
                      v-model="storeForm.storeSortStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="档位">
                    <el-input
                      v-model="storeForm.levelStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="店名(专卖证号)">
                    <el-input
                      v-model="storeForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="客户地址(专卖证号)">
                    <el-input
                      v-model="storeForm.address"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="实际店名">
                    <el-input
                      v-model="storeForm.realStoreName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="实际地址">
                    <el-input
                      v-model="storeForm.realAddress"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="专卖证号">
                    <el-input
                      v-model="storeForm.certificateNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="本香门店码">
                    <el-input
                      v-model="storeForm.benxiangStoreNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="店主">
                    <el-input
                      v-model="storeForm.ownerName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="电话">
                    <el-input
                      v-model="storeForm.phone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="云产卷烟陈列现状">
                    <el-input
                      v-model="storeReportForm.yunDisplayStatusStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="集中陈列条数">
                    <el-input
                      v-model="storeReportForm.displayCount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="集中陈列格数">
                    <el-input
                      v-model="storeReportForm.displayGridStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="有无陈列调整">
                    <el-input
                      v-model="storeReportForm.isDisplayAdjustStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item label="睿终端走访照片">
                    <show-preview
                      :arr-file-data="picList"
                      :is-show-name="true"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              中烟拜访信息信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="走访日期">
                    <el-input
                      v-model="tobaccoReportForm.visitDateStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="走访人">
                    <el-input
                      v-model="tobaccoReportForm.visitUser"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="签到时间">
                    <el-input
                      v-model="tobaccoReportForm.signInTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="走访完成时间">
                    <el-input
                      v-model="tobaccoReportForm.signOutTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="所在省区">
                    <el-input
                      v-model="tobaccoReportForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="所在城市">
                    <el-input
                      v-model="tobaccoReportForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="所在区县">
                    <el-input
                      v-model="tobaccoReportForm.countyName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="店名">
                    <el-input
                      v-model="tobaccoReportForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="地址">
                    <el-input
                      v-model="tobaccoReportForm.address"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="零售户类型">
                    <el-input
                      v-model="tobaccoReportForm.storeSortStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="在店时长(分钟)">
                    <el-input
                      v-model="tobaccoReportForm.duration"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="专卖证号">
                    <el-input
                      v-model="tobaccoReportForm.certificateNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="本香门店码">
                    <el-input
                      v-model="tobaccoReportForm.benxiangNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="客户编码">
                    <el-input
                      v-model="tobaccoReportForm.customerNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="档位">
                    <el-input
                      v-model="tobaccoReportForm.level"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="联系人">
                    <el-input
                      v-model="tobaccoReportForm.linkman"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="联系电话">
                    <el-input
                      v-model="tobaccoReportForm.phone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="业态">
                    <el-input
                      v-model="tobaccoReportForm.businessStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="规模">
                    <el-input
                      v-model="tobaccoReportForm.scaleStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="标签">
                    <el-input
                      v-model="tobaccoReportForm.tag"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="匹配结果">
                    <el-input
                      v-model="tobaccoReportForm.matchResultStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审核状态">
                    <el-input
                      v-model="tobaccoReportForm.auditStatusStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="tobaccoReportForm.auditStatus !== 1"
                  :span="24"
                >
                  <el-form-item label="审核意见">
                    <el-input
                      v-model="tobaccoReportForm.auditRemark"
                      type="textarea"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="tobaccoReportForm.auditStatus === 3"
                :gutter="10"
              >
                <el-col :span="6">
                  <el-form-item label="是否执行驳回">
                    <el-input
                      v-model="tobaccoReportForm.isExecuteRejectStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="tobaccoReportForm.isExecuteReject === 1"
                  :span="6"
                >
                  <el-form-item label="驳回执行人">
                    <el-input
                      v-model="tobaccoReportForm.executeUserName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="tobaccoReportForm.isExecuteReject === 1"
                  :span="6"
                >
                  <el-form-item label="驳回执行时间">
                    <el-input
                      v-model="tobaccoReportForm.executeTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="eventType === 'view'"
            class="modal-box"
          >
            <h3 class="modal-title">
              操作信息信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="审核人">
                    <el-input
                      v-model="tobaccoReportForm.auditorName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审核时间">
                    <el-input
                      v-model="tobaccoReportForm.auditTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="操作人">
                    <el-input
                      v-model="tobaccoReportForm.operatorName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="操作时间">
                    <el-input
                      v-model="tobaccoReportForm.operationTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="eventType === 'audit'"
            class="modal-box"
          >
            <h3 class="modal-title">
              审核信息
            </h3>
            <div class="modal-row-box">
              <el-alert
                v-if="timeError || signError || noWarning || tagWarning || linkWarning"
                title="审核提示"
                type="warning"
                show-icon
                :closable="false"
                style="padding: 5px 5px;"
              />
              <el-alert
                v-if="timeError"
                title="本拜访报告停留时间不足15/10分钟，未达到要求，需要驳回。"
                type="warning"
                :closable="false"
                style="padding: 5px 5px;"
              />
              <el-alert
                v-if="signError"
                title="本拜访报告无签退记录，未达到需求，需要驳回。"
                type="warning"
                :closable="false"
                style="padding: 5px 5px;"
              />
              <el-alert
                v-if="noWarning"
                title="本户中烟终端档案无本香门店码信息，建议审核通过，但在审核意见中标注，并提示走访人员及时注册。"
                type="warning"
                :closable="false"
                style="padding: 5px 5px;"
              />
              <el-alert
                v-if="tagWarning"
                title="本户中烟终端档案未标注标签，建议审核通过，但在审核意见中标注，并提示走访人员及时完善标签标注。"
                type="warning"
                :closable="false"
                style="padding: 5px 5px;"
              />
              <el-alert
                v-if="linkWarning"
                title="本户中烟终端档案联系人/联系电话缺失，建议审核通过，但在审核意见中标注，并提示走访人员及时完善联系信息。"
                type="warning"
                :closable="false"
                style="padding: 5px 5px;"
              />
              <el-alert
                v-if="certificateNoWarning"
                title="本户中烟终端档案与睿终端档案专卖证号不一致，建议审核通过，但在审核意见中标注，并提示走访人员及时确认修改档案专卖证号。"
                type="warning"
                :closable="false"
                style="padding: 5px 5px;"
              />
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="云产卷烟陈列现状"
                    required
                  >
                    <el-radio-group
                      v-model="dialogAddEditViewForm.yunDisplayStatus"
                    >
                      <el-radio :label="1">
                        有陈列
                      </el-radio>
                      <el-radio :label="0">
                        无陈列
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditViewForm.yunDisplayStatus === 1"
                  :span="6"
                >
                  <el-form-item
                    label="集中陈列条数"
                    required
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.displayCount"
                      :min="0"
                      :max="100"
                      :step="1"
                      step-strictly
                      style="width:90%"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditViewForm.yunDisplayStatus === 1"
                  :span="6"
                >
                  <el-form-item
                    label="集中陈列格数"
                    required
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.displayGrid"
                      filterable
                      clearable
                      placeholder="请选择陈列格数"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in displayGridOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    label="审核结果"
                    prop="auditStatus"
                  >
                    <el-radio-group
                      v-model="dialogAddEditViewForm.auditStatus"
                      @change="changeAuditResultFun"
                    >
                      <el-radio
                        :label="2"
                        :disabled="auditPassDisabled"
                      >
                        通过
                      </el-radio>
                      <el-radio
                        :label="3"
                      >
                        驳回
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    prop="auditRemark"
                    label="审核意见"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.auditRemark"
                      type="textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 图片预览
import showPreview from '@/components/showPreview'
// 数据请求
import { initTobaccoVisitListApi, saveOrUpdateTobaccoVisitListApi } from '@/api/tobaccoVisitList'
import { initStoreVisitReportApi } from '@/api/storeVisitReport'
import { loadDictDataApi } from '@/api/dict'
export default {
  components: { showPreview },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      storeReportForm: {},
      storeForm: {},
      tobaccoReportForm: {},
      dialogAddEditViewFormRules: {
        auditStatus: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        auditRemark: [{ max: 256, message: '最多输入256个字符', trigger: 'blur' } ]
      },
      baseUrl: '',
      picList: [],
      displayGridOptions: [],
      auditPassDisabled: false,
      timeError: false,
      signError: false,
      noWarning: false,
      tagWarning: false,
      linkWarning: false,
      certificateNoWarning: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.displayGridOptions = []
        this.auditPassDisabled = false
        this.timeError = false
        this.signError = false
        this.noWarning = false
        this.tagWarning = false
        this.linkWarning = false
        this.certificateNoWarning = false
        this.dialogAddEditViewFormRules = {auditStatus: [{ required: true, message: '请选择审核结果', trigger: 'change' }]}
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picList = []
        this.storeForm = {}
        this.storeReportForm = {}
        this.tobaccoReportForm = {}
        this.dialogAddEditViewForm = {
          yunDisplayStatus: 0,
          displayCount: 0,
          displayGrid: null,
          auditStatus: null,
          auditRemark: ''
        }
        if(this.eventType === 'audit'){
          this.dialogAddEditViewForm.isAudit = 1
        } else if (this.eventType === 'execute'){
          this.dialogAddEditViewForm.isExecute = 1
        }
        this.initDisplayGridSelectData()
        this.initPageData()
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      let _this = this
      initTobaccoVisitListApi({ id: this.dataId }).then(res => {
        const { data } = res
        _this.tobaccoReportForm = data
        _this.dialogAddEditViewForm.id = data.id
        // 无签退强制驳回
        if(data.signOutTimeStr === null || data.signOutTimeStr === ''){
          _this.auditPassDisabled = true
          _this.signError = true
          _this.dialogAddEditViewForm.auditStatus = 3
          if(_this.dialogAddEditViewForm.auditRemark === ''){
            _this.dialogAddEditViewForm.auditRemark = '本拜访报告无签退记录，未达到需求。'
          } else {
            _this.dialogAddEditViewForm.auditRemark += '本拜访报告无签退记录，未达到需求。'
          }
        } else {
          //潜力小于10分钟强制驳回
          if(data.storeSort === 3){
            if(data.duration < 10){
              _this.auditPassDisabled = true
              _this.timeError = true
              _this.dialogAddEditViewForm.auditStatus = 3
              
              if(_this.dialogAddEditViewForm.auditRemark === ''){
                _this.dialogAddEditViewForm.auditRemark = '本拜访报告停留时间不足10分钟，未达到要求。'
              } else {
                _this.dialogAddEditViewForm.auditRemark += '本拜访报告停留时间不足10分钟，未达到要求。'
              }
            }
          } else {
            //重点或信息小于15分钟强制驳回
            if(data.duration < 15){
              _this.auditPassDisabled = true
              _this.timeError = true
              _this.dialogAddEditViewForm.auditStatus = 3
              
              if(_this.dialogAddEditViewForm.auditRemark === ''){
                _this.dialogAddEditViewForm.auditRemark = '本拜访报告停留时间不足15分钟，未达到要求。'
              } else {
                _this.dialogAddEditViewForm.auditRemark += '本拜访报告停留时间不足15分钟，未达到要求。'
              }
            }
          }
        }
        // 无本香门店码
        if(data.benxiangNo === ''){
          _this.noWarning = true
          if(_this.dialogAddEditViewForm.auditRemark === ''){
            _this.dialogAddEditViewForm.auditRemark = '本户中烟终端档案无本香门店码信息，请及时注册。'
          } else {
            _this.dialogAddEditViewForm.auditRemark += '本户中烟终端档案无本香门店码信息，请及时注册。'
          }
        }
        // 无标签
        if(data.tag === ''){
          _this.tagWarning = true
          if(_this.dialogAddEditViewForm.auditRemark === ''){
            _this.dialogAddEditViewForm.auditRemark = '本户中烟终端档案未标注标签，请及时完善标签标注。'
          } else {
            _this.dialogAddEditViewForm.auditRemark += '本户中烟终端档案未标注标签，请及时完善标签标注。'
          }
        }
        // 联系人联系电话缺失
        if(data.linkman === '' || data.phone === ''){
          _this.linkWarning = true
          if(_this.dialogAddEditViewForm.auditRemark === ''){
            _this.dialogAddEditViewForm.auditRemark = '本户中烟终端档案联系人/联系电话缺失，请及时完善联系信息。'
          } else {
            _this.dialogAddEditViewForm.auditRemark += '本户中烟终端档案联系人/联系电话缺失，请及时完善联系信息。'
          }
        }
        if(data.reportId > 0){
          initStoreVisitReportApi({id: data.reportId}).then(res1 => {
            _this.storeForm = res1.data.store
            _this.storeReportForm = res1.data.bill
            if(res1.data.bill.pic1 !== null && res1.data.bill.pic1 !== '' && res1.data.bill.pic1 !== undefined){
              let obj = {}
              obj.name = '门头照'
              obj.url = _this.baseUrl + res1.data.bill.pic1
              obj.attachmentName = '门头照'
              obj.attachmentUrl = res1.data.bill.pic1
              _this.picList.push(obj)
            }
            if(res1.data.bill.pic2 !== null && res1.data.bill.pic2 !== '' && res1.data.bill.pic2 !== undefined){
              let obj = {}
              obj.name = '整体陈列照'
              obj.url = _this.baseUrl + res1.data.bill.pic2
              obj.attachmentName = '整体陈列照'
              obj.attachmentUrl = res1.data.bill.pic2
              _this.picList.push(obj)
            }
            if(res1.data.bill.pic3 !== null && res1.data.bill.pic3 !== '' && res1.data.bill.pic3 !== undefined){
              let obj = {}
              obj.name = '云产烟陈列照'
              obj.url = _this.baseUrl + res1.data.bill.pic3
              obj.attachmentName = '云产烟陈列照'
              obj.attachmentUrl = res1.data.bill.pic3
              _this.picList.push(obj)
            }
            if(res1.data.bill.pic5 !== null && res1.data.bill.pic5 !== '' && res1.data.bill.pic5 !== undefined){
              let obj = {}
              obj.name = '调整前陈列照'
              obj.url = _this.baseUrl + res1.data.bill.pic5
              obj.attachmentName = '调整前陈列照'
              obj.attachmentUrl = res1.data.bill.pic5
              _this.picList.push(obj)
            }
            if(res1.data.bill.pic4 !== null && res1.data.bill.pic4 !== '' && res1.data.bill.pic4 !== undefined){
              let obj = {}
              obj.name = '调整后陈列照'
              obj.url = _this.baseUrl + res1.data.bill.pic4
              obj.attachmentName = '调整后陈列照'
              obj.attachmentUrl = res1.data.bill.pic4
              _this.picList.push(obj)
            }
            if(_this.storeReportForm.yunDisplayStatus){
              _this.dialogAddEditViewForm.yunDisplayStatus = _this.storeReportForm.yunDisplayStatus
              _this.dialogAddEditViewForm.displayCount = _this.storeReportForm.displayCount
              _this.dialogAddEditViewForm.displayGrid = _this.storeReportForm.displayGrid
            }
            // 专卖证号不一致
            if(data.certificateNo !== _this.storeForm.certificateNo){
              _this.certificateNoWarning = true
              if(_this.dialogAddEditViewForm.auditRemark === ''){
                _this.dialogAddEditViewForm.auditRemark = '本户中烟终端档案与睿终端档案专卖证号不一致，请及时确认修改档案专卖证号。'
              } else {
                _this.dialogAddEditViewForm.auditRemark += '本户中烟终端档案与睿终端档案专卖证号不一致，请及时确认修改档案专卖证号。'
              }
            }
            _this.loading = false
          })
        } else {
          _this.loading = false
        }
      })
    },
    // 初始陈列格数下拉数据
    initDisplayGridSelectData(){
      loadDictDataApi({ type: 32 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.displayGridOptions.push({ label: item.optionLable, data: item.optionValue })
        })
      })
    },
    // 选择审核结果回调
    changeAuditResultFun(val){
      if(val === 2){
        this.dialogAddEditViewFormRules.auditRemark = [{ max: 256, message: '最多输入256个字符', trigger: 'blur' } ]
      } else {
        this.dialogAddEditViewFormRules.auditRemark = [{ required: true, message: '请录入审核意见', trigger: 'blur' },{ max: 256, message: '最多输入256个字符', trigger: 'blur' } ]
      }
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'audit' ? '是否确定审核' : '是否确定执行驳回') + '该中烟走访信息', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              if(this.dialogAddEditViewForm.yunDisplayStatus === 0){
                this.dialogAddEditViewForm.displayCount = 0
                this.dialogAddEditViewForm.displayGrid = 0
              }
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateTobaccoVisitListApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.search-box {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 10px;
}
.left {
  width: 100%;
  height: 250px;
  border: 1px solid #e6ebf5;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.right {
  width: 100%;
  height: 250px;
  border: 1px solid #e6ebf5;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-top: 48px;
  margin-bottom: 10px;
}
.left {
  padding: 5px 0;
}
.left li {
  padding: 0 5px;
}
.left-list-box {
  overflow-x: hidden;
  overflow: auto;
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  line-height: 20px;
}
.transfer-button {
  width: 70px;
  float: left;
  padding-top: 120px;
  text-align: center;
}
.transfer-button .el-button {
  margin: 10px 0;
  flex: 1;
}
.right {
  width: 100%;
}
.right-list,
.list-complete-item {
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
  display: flex;
  overflow-x: hidden;
}
.right-list li,
.list-complete-item li {
  padding: 0 5px;
  margin: 0;
  line-height: 24px;
  border-bottom: 1px solid #e6ebf5;
  flex: 1;
}
li.order {
  flex: 0 1 60px;
  width: 60px;
  border-right: 1px solid #e6ebf5;
}
li.employee {
  border-right: 1px solid #e6ebf5;
  text-align: center;
}
.right-list > li {
  background: #efefef;
}
.li:hover {
  background: #b2e1ff;
}
.active {
  background: #7fceff;
}
.right-list-box {
  height: 224px;
  overflow-x: hidden;
  overflow: auto;
}
</style>
